
import getSidebarNavItems from "../components/layout/data/sidebar-nav-items";
import types from "../types/types";

export const storeHelper = (userRoleName) => {

    const userRole = (userRoleName) ? userRoleName : types.ROLES[3].name;

    let _store = {
        menuVisible: false,
        navItems: getSidebarNavItems(userRole)
    };

    return _store;
}

export default storeHelper;







